import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowDown } from "lucide-react";
import { HERO_IMAGE } from "../../../data/destinations";

const scrollTo = (id) => () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export const HomeHero = () => (
  <section data-testid="home-hero" className="relative min-h-[100svh] w-full overflow-hidden">
    <div className="absolute inset-0">
      <img src={HERO_IMAGE} alt="Sunrise yoga on a yacht deck over calm open sea" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-black/40" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60" />
    </div>

    <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-[1400px] flex-col justify-center px-6 pt-32 pb-16 md:px-10">
      <div className="max-w-3xl fade-up">
        <p className="overline text-white/85">Yoga · Wellness · Sailing · Yacht retreats</p>
        <h1 data-testid="hero-title" className="hero-h1 mt-6 text-4xl text-white sm:text-5xl md:text-6xl lg:text-7xl">
          Find your perfect <em>yoga, wellness, or yacht</em> retreat
        </h1>
        <p data-testid="hero-subtitle" className="mt-7 max-w-xl text-base text-white/85 md:text-lg">
          Discover retreats that match your mood, budget, destination, and travel style —
          from peaceful sunrise yoga to sunset decks at sea.
        </p>
        <div className="mt-9 flex flex-wrap items-center gap-3">
          <Link
            data-testid="hero-cta-primary"
            to="/find-my-retreat"
            className="inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-medium text-brand-ink transition-colors duration-300 hover:bg-brand-bg2"
          >
            Find My Retreat <ArrowRight size={16} />
          </Link>
          <button
            data-testid="hero-cta-secondary"
            onClick={scrollTo("escapes")}
            className="inline-flex items-center gap-2 rounded-full border border-white/40 px-7 py-3.5 text-sm font-medium text-white backdrop-blur-md transition-colors duration-300 hover:bg-white/10"
          >
            Explore Retreats <ArrowDown size={16} />
          </button>
        </div>
      </div>
    </div>
  </section>
);

export default HomeHero;
